module.exports = __webpack_public_path__ + "img/杨强-4x.f25b66d1.png";